import type { FC } from "react";
import { DownloadIcon } from "lucide-react";

type PdfViewerProps = {
  fileId: string;
  fileName: string;
};

export const PdfViewer: FC<PdfViewerProps> = ({ fileId, fileName }) => {
  const fileUrl = `/api/file/${fileId}`;

  return (
    <div className="flex flex-col h-full w-full">
      <object
        data={fileUrl}
        type="application/pdf"
        className="w-full h-full rounded-lg"
      >
        <div className="flex flex-col items-center justify-center h-full gap-4">
          <p className="text-sm text-zinc-500">
            PDF preview not available in your browser.
          </p>
          <button
            className="flex items-center gap-2 px-4 py-2 rounded bg-blue-600 text-white text-sm hover:bg-blue-700 transition-colors"
            onClick={() => window.open(fileUrl, "_blank")}
          >
            <DownloadIcon className="w-4 h-4" />
            Download PDF
          </button>
        </div>
      </object>
    </div>
  );
};
